import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/weedar.png'
import _imports_1 from '../assets/images/unlogin_avatar.png'


const _withScopeId = n => (_pushScopeId("data-v-4a1dfe58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout--wrap flex direction-column flex-grow-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "layout__empty" }, null, -1))
const _hoisted_3 = ["alt"]
const _hoisted_4 = {
  key: 1,
  class: "border"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sign in")
const _hoisted_6 = {
  key: 3,
  class: "unlogin__avatar",
  src: _imports_1
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasePreloader = _resolveComponent("BasePreloader")!
  const _component_BaseBurger = _resolveComponent("BaseBurger")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LocaleSwitcher = _resolveComponent("LocaleSwitcher")!
  const _component_MainMenu = _resolveComponent("MainMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BasePreloader),
    _createElementVNode("header", {
      class: _normalizeClass(["layout__header flex align-center justify-between justify-center-sm", [
        { isRightBg: _ctx.bgRightHeader && !_ctx.isMobile },
        { isAllBg: _ctx.bgAllHeader && !_ctx.isMobile },
        { mobHeader: _ctx.mobHeader && _ctx.isMobile },
      ]])
    }, [
      _createVNode(_component_BaseBurger, {
        "is-open": _ctx.isOpenMenu,
        "onUpdate:is-open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpenMenu) = $event))
      }, null, 8, ["is-open"]),
      _hoisted_2,
      _createVNode(_component_router_link, {
        to: { name: _ctx.ROUTES.COLLECTIONS.name },
        class: _normalizeClass({ headerIndex: _ctx.headerIndex })
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            alt: _ctx.t('logo'),
            class: "layout__logo"
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["to", "class"]),
      (!_ctx.isMobile || (_ctx.isMobile && _ctx.isOpenMenu))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["flex layout__header__right", { headerIndex: _ctx.headerIndex }])
          }, [
            (!_ctx.isMobile || (_ctx.isMobile && _ctx.isOpenMenu))
              ? (_openBlock(), _createBlock(_component_LocaleSwitcher, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4))
              : _createCommentVNode("", true),
            (!_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: { name: _ctx.ROUTES.LOGIN.name },
                  class: "sign__in flex align-center"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_MainMenu, {
      "is-open": _ctx.isOpenMenu,
      "onUpdate:is-open": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isOpenMenu) = $event))
    }, null, 8, ["is-open"]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}